import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {lastValueFrom} from 'rxjs';
import {ItemClickEvent} from 'devextreme/ui/list';
import {ValueChangedEvent as NumberBoxValueChangeEvent} from 'devextreme/ui/number_box';

import {NextPimField} from 'app/Model/Catalog/NextPimField';
import {TemplateService} from 'app/Services/template.service';
import {TemplateItem} from 'app/Model/Catalog/TemplateItem';
import {comparePimFields, fillLastKey, isNextPimField, parsePimField} from 'app/Services/templateItemHelpers';
import {TemplateItemTemplate} from '../../Model/Catalog/TemplateItemTemplate';
import {TemplateFieldsService} from "../../Services/templateFields.service";
import {LoginService} from "../../Services/login.service";
import {WawiSettingsService} from "../../Services/wawiSettingsService.service";

@Component({
    selector: 'np-advanced-template-listfield',
    templateUrl: './advanced-template-listfield.component.html',
    standalone: false
})
export class AdvancedTemplateListFieldComponent implements OnInit {
  @Input() templateItem: TemplateItem;
  @Output() onUpdate = new EventEmitter<void>();
  @Input() fieldList: TemplateItemTemplate[] = [];


  public customFields: { name: string, id: string }[] = [];

  get pimField() {
    if (!this.templateItem.pimFields || this.templateItem.pimFields.length === 0) {
      this.templateItem.pimFields = [new NextPimField()];
    }
    return this.templateItem.pimFields[0];
  }

  get hasSystem(): boolean {
    const templateItemTemplates = this.fieldList.filter((x) => x.field === this.pimField.field);
    if (templateItemTemplates?.length > 0) {
      return templateItemTemplates[0].system;
    }
    return false;
  }

  constructor(private templateService: TemplateService, private fieldService: TemplateFieldsService, private loginService: LoginService,
              public wawiSettingsService: WawiSettingsService) {
  }

  async ngOnInit() {
    this.normalizeSystemKey(parseInt(this.pimField.systemKey));
    if (this.templateItem.fieldType == 'udx') {
      this.pimField.useSequence = true;
    }

    if (this.fieldList.some(x => x.field == "CUSTOM_FIELD")) {
      let wawiSettings = await lastValueFrom(this.wawiSettingsService.getWawiSettings(this.loginService.currentCustomer.id));
      this.customFields = wawiSettings.customFields.map(x => ({name: x.name, id: x.id}));
    }
  }

  getFieldDisplayExpr(item: TemplateItemTemplate) {
    return item?.text === item?.field ? item?.field ?? '' : `${item.text} (${item.field})`;
  }

  onFieldItemClick(event: ItemClickEvent<TemplateItemTemplate>) {
    this.pimField.field = event.itemData.field;
    this.normalizeSystemKey(parseInt(this.pimField.systemKey));
    this.update();
  }

  onOrderChanged(event: NumberBoxValueChangeEvent) {
    this.normalizeSystemKey(event.value);
    this.update();
  }

  update() {
    const { field, systemKey, elementKey } = this.pimField;
    const parsedKey = parsePimField(this.templateItem.key);
    if (parsedKey !== null && (comparePimFields(parsedKey, this.pimField) || !isNextPimField(parsedKey.field))) {
      this.onUpdate.emit();
      return;
    }
    this.templateService.getHeadline(field, elementKey, systemKey, this.loginService.currentCustomer.id).subscribe((headline) => {
      fillLastKey(this.templateItem, headline.value);
      this.onUpdate.emit();
    });
  }

  private normalizeSystemKey(value: number) {
    if (isNaN(value) || value <= 0) {
      this.pimField.systemKey = '1';
    } else {
      this.pimField.systemKey = value.toString();
    }
    this.pimField.elementKey = '-1';
  }
}
